import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const FishingIcon = observer('FishingIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            width='24'
            height='24'
            viewBox='0 0 50 50'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <path
                d='M25.73,24.58c-.22.22-.22.59,0,.81s.59.22.81,0,.22-.59,0-.81-.59-.22-.81,0Z'
                fill='fill'
            />
            <path
                d='M36.73,32.6l-3.13-.95c-.26-.89-.62-1.94-1.09-2.99l.38-.38-.34-.41.31-.5-.46-.45.17-.43-.41-.41.09-.62-.65-.31.16-.41-.53-.45.02-.51-2.22.23c-1.89-1.39-3.95-1.66-5.25-1.67l.33,1.59-1.71-1.26c-.12.94-.35,4.53,2.45,7.33,1.89,1.89,4.75,3,6.8,3.59l.95,3.13c.1.33.55.37.71.07l.2-.38.42-2.48,2.48-.42.38-.2c.31-.16.26-.61-.07-.71h0ZM26.87,25.72c-.4.4-1.06.4-1.46,0s-.4-1.06,0-1.46,1.06-.4,1.46,0,.4,1.06,0,1.46Z'
                fill='fill'
            />
            <path
                d='M17.99,24.07h.92v.55c0,.72-.59,1.31-1.31,1.31s-1.31-.59-1.31-1.31v-3.93c.66-.28,1.12-.93,1.12-1.7,0-.81-.53-1.49-1.25-1.74-.11-1.54-.64-3.01-1.54-4.25h-1.61c1.11,1.18,1.77,2.67,1.9,4.27-.7.26-1.19.93-1.19,1.72s.46,1.41,1.12,1.7v3.93c0,1.52,1.24,2.76,2.76,2.76s2.76-1.24,2.76-2.76v-3.3l-2.36,2.75h0Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
